import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateTimeoffFormErrors", function updateTimeoffFormErrors(errorCount: number) {
    shiftEditorViewState().timeoffFormErrors = errorCount;
});